import { useQuery } from "react-query";
import { preventiviApi, Preventivo } from "../services/preventiviApi";

export function usePreventivoList(filters?: { q?: string; status_filter?: string; categoria?: string }) {
  const hasProcessing = (data: Preventivo[] | undefined) =>
    data?.some((p) => p.status === "processing") ?? false;

  return useQuery(
    ["preventivi", filters],
    () => preventiviApi.list(filters),
    {
      refetchInterval: (data) => (hasProcessing(data) ? 4000 : false),
      // Serve from cache immediately on navigation; re-fetch silently in background
      // only when the data is older than 20 s (or when a mutation invalidates it).
      staleTime: 20_000,
    }
  );
}
